import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import '../App.css'

export default function ThankYou(){
    const imgCDNURL = process.env.REACT_APP_SUNWESTEXPO_CDN_URL;
     const getSunWestSuccessYears = () => {
    //Sun West founded in 08/12/1980
    const foundedDate = new Date('1980-08-12');
    const todayDate = new Date();    
    const yearDiff = todayDate.getFullYear() - foundedDate.getFullYear();
    const isDate2BeforeBirthday = (
    todayDate.getMonth() < foundedDate.getMonth() ||
    (todayDate.getMonth() === foundedDate.getMonth() && todayDate.getDate() < foundedDate.getDate())
    );
    return isDate2BeforeBirthday ? yearDiff - 1 : yearDiff;
    }
     
    return(
        <div className="thankyoubg">
    <Container  >
        <Row className="thankyoucontent">
        <Col lg-12 md-12>
           
       <img src={imgCDNURL + "cloudimage.webp"} className="thankyouheading img-fluid" 
        alt="Thank you" /> 
 
    <h3 className="thankyou"> Thank You <br/>For Attending The<br/> Great Northwest Expo!</h3> 


    <p className = "thankyoumsg">A Big Thanks to everyone who attended The Great Northwest Expo. We hope that you enjoyed the experience.<br/><br/>
 
 <a href="https://www.swmc.com" target="_self" rel="noopener noreferrer" style={{color: 'inherit', textDecoration: 'none'}} onMouseEnter={(e) => e.target.style.textDecoration = 'underline'} onMouseLeave={(e) => e.target.style.textDecoration = 'none'}>Sun West Mortgage</a> has been helping families achieve their dream of homeownership since 1980. We are so grateful for the {getSunWestSuccessYears()} years of support from our employees, partners, and homebuyers who have made us a household name in the mortgage industry.<br/><br/>
  
 So much has changed in the mortgage industry since 1980, but one thing that will never change is <a href="https://www.swmc.com" target="_self" rel="noopener noreferrer" style={{color: 'inherit', textDecoration: 'none'}} onMouseEnter={(e) => e.target.style.textDecoration = 'underline'} onMouseLeave={(e) => e.target.style.textDecoration = 'none'}>Sun West's</a> commitment to Fair Lending and our ambition to never settle. We refuse to accept mediocre technology, less than great rates, unnecessary fees, and clunky processes. For {getSunWestSuccessYears()} years, we have dedicated ourselves to revolutionizing the mortgage industry and we'll never stop trying to make it even better.<br/><br/>
  
 We look forward to seeing you again at our future events.
 
    </p>
    </Col>
    </Row>
    </Container>
    </div>
    );
}